var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1C21.2098 1 25 10 25 10C25 10 21.2098 19 13 19C4.79015 19 1 10 1 10C1 10 4.79015 1 13 1Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5814 10.0001C16.5924 10.5841 16.5051 11.1647 16.3245 11.708C16.144 12.2513 15.8738 12.7463 15.5299 13.1639C15.1861 13.5815 14.7754 13.9133 14.3221 14.1398C13.8688 14.3664 13.3819 14.4831 12.8901 14.4831C12.3982 14.4831 11.9114 14.3664 11.458 14.1398C11.0047 13.9133 10.594 13.5815 10.2502 13.1639C9.90631 12.7463 9.63617 12.2513 9.4556 11.708C9.27503 11.1647 9.18768 10.5841 9.19868 10.0001C9.19868 8.83718 9.58769 7.72187 10.2801 6.89954C10.9726 6.07721 11.9117 5.61523 12.891 5.61523C13.8702 5.61523 14.8094 6.07721 15.5018 6.89954C16.1943 7.72187 16.5833 8.83718 16.5833 10.0001H16.5814Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/ViewIcon.84b05b765e23eb886394ae1029b6f3ea.svg";
export { ForwardRef as ReactComponent };